<template>
    <div class="mx-5">
        <ValidationObserver ref="obs" v-slot="{ invalid }">
            <v-form name="FormPreHijos" @submit.prevent="submit">
                <v-card flat class="custom-card" v-for="(hijo, index) in itemDataSelected" :key="index">

                    <v-row>
                        <v-card-text class="font-weight-bold text-body-1 black--text">
                            DATOS DE HIJO {{ index + 1 }}
                        </v-card-text>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="6">
                            <ValidationProvider rules="required|alpha_spaces|minmax:2,30" v-slot="{ errors }">
                                <v-text-field v-model="hijo.nombres" @input="hijo.nombres = hijo.nombres.toUpperCase()"
                                    label="Nombres" dense :error-messages="errors"></v-text-field>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="6">
                            <ValidationProvider rules="required|alpha_spaces|minmax:2,30" v-slot="{ errors }">
                                <v-text-field v-model="hijo.apellido" label="Apellido" dense
                                    @input="hijo.apellido = hijo.apellido.toUpperCase()"
                                    :error-messages="errors"></v-text-field>
                            </ValidationProvider>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="4">
                            <ValidationProvider rules="required|length:8|numeric" v-slot="{ errors }">
                                <v-text-field v-model="hijo.nrodoc" label="DNI Nro." dense
                                    :error-messages="errors"></v-text-field>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="2">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <v-select dense v-model="hijo.sexo" :items="['F', 'M', 'X']" label="Sexo"
                                    :error-messages="errors">
                                </v-select>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="6">
                            <ValidationProvider rules="required|max:10" v-slot="{ errors }">
                                <v-text-field v-model="hijo.fecnacim" label="Fecha de nacimiento" dense
                                    :error-messages="errors" type="date"></v-text-field>
                            </ValidationProvider>
                        </v-col>
                        <v-col cols="12" md="12">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <v-select v-model="hijo.discapacidad" :items="discapacidadOptions" item-text="text"
                                    item-value="value" label="Discapacitado" :error-messages="errors" dense></v-select>
                            </ValidationProvider>
                        </v-col>
                    </v-row>
                    <v-divider class="my-5"></v-divider>
                    <v-row>
                        <v-card-text class="font-weight-bold text-body-1 black--text ">
                            DOCUMENTACIÓN REQUERIDA:
                        </v-card-text>
                    </v-row>
                    <v-row class="d-flex justify-space-around align-end">
                        <InputButtonArchivo @fileSelected="handleFileSelected(index)"
                            :op="'dniFrenteHijo' + (index + 1)" label="DNI FRENTE"
                            :subtitle="hijo.nombres + ' ' + hijo.apellido" />
                        <InputButtonArchivo @fileSelected="handleFileSelected(index)" :op="'dniDorsoHijo' + (index + 1)"
                            label="DNI DORSO" :subtitle="hijo.nombres + ' ' + hijo.apellido" />
                        <InputButtonArchivo @fileSelected="handleFileSelected(index)"
                            :op="'partidaNacHijo' + (index + 1)" label="PARTIDA DE NACIMIENTO"
                            :subtitle="hijo.nombres + ' ' + hijo.apellido" />
                        <InputButtonArchivo v-if="(hijo.discapacidad == 'S')" @fileSelected="handleFileSelected(index)"
                            :op="'certDiscHijo' + (index + 1)" label="CUD" subtitle="CERT DE DISCAPACIDAD" />
                    </v-row>
                </v-card>
                <div class="d-flex justify-space-between form-footer" @click="forzarValidacion">
                    <v-btn color="secondary" outlined elevation="0" @click="volver" class="pa-5">
                        <v-icon class="mr-2">mdi-chevron-left</v-icon>atras
                    </v-btn>
                    <!-- || !formValid -->
                    <v-btn color="primary" elevation="0" type="submit" :disabled="invalid || !formValid" class="pa-5">
                        <v-icon class="mr-2">mdi-chevron-right</v-icon>siguiente
                    </v-btn>
                </div>
            </v-form>
        </ValidationObserver>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import InputButtonArchivo from '@/components/inputs/InputButtonArchivo.vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
    name: 'FormPreHijos',
    components: {
        InputButtonArchivo,
        ValidationProvider,
        ValidationObserver
    },
    data() {
        return {
            // data
            itemDataSelected: [],

            discapacidadOptions: [
                { text: 'SI', value: 'S' },
                { text: 'NO', value: 'N' },
            ],
            formValid: false,
        }
    },
    computed: {
        ...mapGetters('common', ['sexo', 'nacionalidades']),
        ...mapGetters('preafiliacion', ['cantHijos', 'archivosHijos']),
    },

    watch: {
        cantHijos: {
            immediate: true,
            handler(newVal) {
                this.itemDataSelected = Array.from({ length: newVal }, () => ({
                    nombres: '',
                    apellido: '',
                    tipdoc: 'DNI',
                    nrodoc: '',
                    fecnacim: '',
                    sexo: '',
                    desnacionalidad: '',
                    nacionalidad: 1,
                    tipfamiliar: 3,
                    destipfamiliar: 'HIJO',
                    discapacidad: 'N',
                    estadocivil: 1,
                    fecfallecido: '1900-01-01',
                    fecestadocivil: '1900-01-01',
                    tipnacionalidad: 1,
                }));
            }
        },
    },
    methods: {
        ...mapActions('preafiliacion', ['addFilesPre', 'guardarDatosHijos']),
        // methods
        submit() {
            this.$refs.obs.validate().then(success => {
                if (success) {
                    this.guardarDatosHijos(this.itemDataSelected)
                    this.$emit('siguiente')
                    // submit
                }
            })
        },
        forzarValidacion() {
            this.$refs.obs.validate().then(result => {
                if (!result) {
                    const firstErrorElement = this.$el.querySelector('.v-messages__message');
                    if (firstErrorElement) firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            });
        },
        volver() {
            this.$emit('atras')
        },
        handleFileSelected() {
            // Verifica que para cada hijo se cumplan los archivos requeridos según discapacidad
            this.formValid = this.itemDataSelected.every((hijo, index) => {
                const archivos = this.archivosHijos[index] || {};
                if (hijo.discapacidad === "S") {
                    return archivos.dniFrenteHijo && archivos.dniDorsoHijo && archivos.certDiscHijo && archivos.partidaNac;
                } else {
                    return archivos.dniFrenteHijo && archivos.dniDorsoHijo && archivos.partidaNac;
                }
            });
        },

    }
}
</script>

<style scoped>
.custom-card {
    position: relative;
    height: 100%;
    cursor: default;
    padding-bottom: 80px;
    /* Espacio suficiente para las acciones */
}
</style>